import { render, staticRenderFns } from "./article-group.vue?vue&type=template&id=0d8676e4"
import script from "./article-group.vue?vue&type=script&lang=js"
export * from "./article-group.vue?vue&type=script&lang=js"
import style0 from "./article-group.vue?vue&type=style&index=0&id=0d8676e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports